import { render, staticRenderFns } from "./MainFolderAITrip.vue?vue&type=template&id=63d523a6&scoped=true&"
import script from "./MainFolderAITrip.vue?vue&type=script&lang=js&"
export * from "./MainFolderAITrip.vue?vue&type=script&lang=js&"
import style0 from "./MainFolderAITrip.vue?vue&type=style&index=0&id=63d523a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d523a6",
  null
  
)

export default component.exports